module.exports = {
  WIDGETS: {
    TOOLTIP_OFFSET_Y: 10
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/cartodb-deep-insights.js/src/constants.js
// module id = 657
// module chunks = 2 3